(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ionic-brand-home"] && !Shopify.designMode) return;
  try {
    
  const setupIonicCarousel = (carousel) => {
    if (carousel.dataset.carouselReady === 'true') return;

    const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
    const previous = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (slides.length < 2 || !previous || !next) return;

    carousel.dataset.carouselReady = 'true';
    let activeIndex = 0;
    let timer = null;
    let userPaused = reducedMotion.matches;
    let pointerStart = null;

    const interval = Number(carousel.dataset.interval) || 5000;

    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.querySelectorAll('a').forEach((link) => link.tabIndex = active ? 0 : -1);
      });
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === activeIndex) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (userPaused || reducedMotion.matches || document.hidden) return;
      timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
    };

    const move = (offset) => {
      showSlide(activeIndex + offset);
      start();
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => {
      showSlide(dotIndex);
      start();
    }));

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    carousel.addEventListener('pointerdown', (event) => pointerStart = event.clientX);
    carousel.addEventListener('pointerup', (event) => {
      if (pointerStart === null) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) > 45) move(distance > 0 ? -1 : 1);
    });
    document.addEventListener('visibilitychange', start);
    reducedMotion.addEventListener('change', () => {
      userPaused = reducedMotion.matches;
      start();
    });

    showSlide(0);
    start();
  };

  document.querySelectorAll('[data-ionic-carousel]').forEach(setupIonicCarousel);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-ionic-carousel]').forEach(setupIonicCarousel);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ionic-header"]) return;
  try {
    
  document.addEventListener('submit', (event) => {
    if (!event.target.matches('form.ionic-header__languages')) return;
    const returnTo = event.target.querySelector('input[name="return_to"]');
    if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
  });

  document.addEventListener('toggle', (event) => {
    if (!event.target.matches('details.ionic-header__mobile')) return;
    const summary = event.target.querySelector('summary');
    summary.setAttribute('aria-expanded', String(event.target.open));
    summary.setAttribute('aria-label', event.target.open ? summary.dataset.labelClose : summary.dataset.labelOpen);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('details.ionic-header__mobile[open]');
    if (!menu) return;
    event.preventDefault();
    menu.open = false;
    menu.querySelector('summary').focus();
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ionic-cart-trigger]');
    const drawer = document.getElementById('cart-drawer');
    if (!trigger || !drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.open();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ionic-password"]) return;
  try {
    
  const hideStaleSignupCount = () => {
    document.querySelectorAll('[data-signup-expires]').forEach((node) => {
      if (Date.now() >= Number(node.dataset.signupExpires) * 1000) node.hidden = true;
    });
  };
  hideStaleSignupCount();
  window.setInterval(hideStaleSignupCount, 60000);
  const initializeIonicCountdowns = (scope) => {
    scope.querySelectorAll('[data-ionic-countdown]').forEach((countdown) => {
      if (countdown.dataset.countdownReady === 'true') return;

      const target = Date.parse(countdown.dataset.countdownTarget);
      const grid = countdown.querySelector('.ionic-gate__countdown-grid');
      const liveMessage = countdown.querySelector('[data-countdown-live]');
      const fields = {
        days: countdown.querySelector('[data-countdown-unit="days"]'),
        hours: countdown.querySelector('[data-countdown-unit="hours"]'),
        minutes: countdown.querySelector('[data-countdown-unit="minutes"]'),
        seconds: countdown.querySelector('[data-countdown-unit="seconds"]')
      };

      if (Number.isNaN(target) || !grid || !liveMessage) return;

      const render = () => {
        const distance = target - Date.now();

        if (distance <= 0) {
          grid.hidden = true;
          liveMessage.hidden = false;
          window.clearInterval(countdown.ionicCountdownInterval);
          return;
        }

        const totalSeconds = Math.floor(distance / 1000);
        fields.days.textContent = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
        fields.hours.textContent = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, '0');
        fields.minutes.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        fields.seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
      };

      countdown.dataset.countdownReady = 'true';
      render();
      countdown.ionicCountdownInterval = window.setInterval(render, 1000);
    });
  };

  initializeIonicCountdowns(document);
  document.addEventListener('shopify:section:load', (event) => initializeIonicCountdowns(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-ionic-countdown]').forEach((countdown) => {
      window.clearInterval(countdown.ionicCountdownInterval);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
